interface DisputeCardsProps {
    value: string;
    onChange: (v: string) => void;
}

const DISPUTES = [
    {
        key: 'Civil',
        label: 'Civil Dispute',
        desc: 'A civil matter is a dispute between people or organisations about rights, money, property, or agreements.',
        examples: [
            'Landlord and tenant issues',
            'Unpaid debts or loans',
            'Contract or business disagreements',
            'Employment disputes (salary, termination)',
            'Family or property disputes',
        ],
    },
    {
        key: 'Criminal',
        label: 'Criminal Dispute',
        desc: 'A criminal matter involves an act that is considered an offence against the law, such as fraud, theft, assault, or threats.',
        examples: ['Fraud or scams', 'Theft or robbery', 'Assault or threats', 'Forgery or impersonation'],
    },
];

export default function DisputeCards({ value, onChange }: DisputeCardsProps) {
    return (
        <div className="grid gap-4 sm:grid-cols-2">
            {DISPUTES.map((d) => (
                <label
                    key={d.key}
                    className={`cursor-pointer rounded-xl border p-5 transition-colors ${
                        value === d.key ? 'border-primary' : 'border-[#eee]'
                    }`}
                >
                    <div className="flex items-center gap-3">
                        <input
                            type="radio"
                            checked={value === d.key}
                            onChange={() => onChange(d.key)}
                            className="sr-only"
                        />
                        <div
                            className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border transition-all ${
                                value === d.key ? 'border-primary' : 'border-[#ccc]'
                            }`}
                        >
                            <div
                                className={`h-2 w-2 rounded-full transition-all ${
                                    value === d.key ? 'bg-primary scale-100' : 'bg-transparent scale-0'
                                }`}
                            />
                        </div>
                        <span className="text-[14px] font-bold text-secondary">{d.label}</span>
                    </div>
                    {/* <p className="mt-3 text-[12px] leading-relaxed text-[#555]">{d.desc}</p> */}
                    {/* <p className="mt-2 text-[12px] text-[#555]">Common examples:</p> */}
                    {/* <ul className="mt-1 list-inside list-disc text-[12px] text-[#555]">
                        {d.examples.map((ex) => (
                            <li key={ex}>{ex}</li>
                        ))}
                    </ul> */}
                </label>
            ))}
        </div>
    );
}
